module.exports = __webpack_public_path__ + "assets/images/grid/covid-hits-home-13.jpg?v=3e5becf1";